export default __webpack_public_path__ + "static/media/recent_activity_4.cb972099.jpg";